import { apiCall } from "./api";
import { CONFIG } from "../config";
import { UserCreateResponse, UserEditResponse } from "./types";

export async function createUser(
  userName: string,
  publicKeyBase64: string,
  secretKey: string
) {
  return apiCall<UserCreateResponse>(
    "UserCreateFunction",
    {
      body: {
        name: userName,
        secret_key: secretKey,
        public_key: publicKeyBase64,
        type: "untrusted",
        baseUrl: CONFIG.apiUrlMain
      },
    }
  );
}

export async function editUsername(
  name: string,
  accessToken: string
) {
  return apiCall<UserEditResponse>(
    "UserEditFunction",
    {
      token: accessToken,
      body: { name },
      baseUrl: CONFIG.apiUrlMain
    }
  );
}
